import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"

import { AttachmentFragment } from "entities/attachments/graphql/fragments.generated"
import { LinkedAttachmentEntity } from "entities/attachments/ui/linked-attachments/types/LinkedAttachmentEntity"

import { ReplaceAttachmentOverlayModel } from "../ReplaceAttachmentOverlay"

export interface ReplaceAttachmentOverlayViewModel {
  existingFile: AttachmentFragment
  newFile: AttachmentFragment | null
  linkedEntities: LinkedAttachmentEntity[] | undefined
  isLoading: boolean
  onUpload: (filePreview: FilePreview) => Promise<ApiResponse<unknown>>
  onConfirm: () => void
  onClose: () => void
}

export function useReplaceAttachmentOverlayViewModel({
  payload,
  linkedEntities,
  newFile,
  isLoading,
  onUpload,
  onConfirm,
  onClose
}: ReplaceAttachmentOverlayModel): ReplaceAttachmentOverlayViewModel {
  return {
    existingFile: payload.attachment,
    newFile,
    linkedEntities,
    isLoading,
    onUpload,
    onConfirm,
    onClose
  }
}
